module.exports = __webpack_public_path__ + "static/media/img-entregues-pqdosprincipes-06.fc41bcc2.jpg";